enum SubpageName {
    Home = 'home',
    PageConfig = 'page-config',
    BannerConfig = 'banner-config',
    FeeConfig = 'fee-config',
    FeeExplainerPortal = 'fee-explainer-portal',
    FeeChangeWorkflow = 'fee-change-workflow',
    OtherConfig = 'other-config',
    OnlineFeeExplainerConfig = 'online-fee-explainer-config'
}

export default SubpageName;
